export const siteConfig = {
  experience: {
    ANNOUNCE: 'announce',
    REGISTRATION: 'registration',
    COUNTDOWN: 'countdown',
    CONFERENCE: 'conference',
    AFTER_CONFERENCE: 'afterConference',
  },
}
